import { ColoredIconSoundOn } from '@croquiscom-pvt/zds';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const PlayableWrap = ({ margin = 8, buttonSize = 32 }: { margin?: number | 'auto'; buttonSize?: number }) => {
  return (
    <ButtonWrap customMargin={margin} size={buttonSize}>
      <ColoredIconSoundOn size={buttonSize} />
    </ButtonWrap>
  );
};

const ButtonWrap = styled.div<{ customMargin: number | 'auto'; size: number }>`
  position: absolute;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  ${(props) =>
    props.customMargin === 'auto'
      ? css`
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        `
      : css`
          bottom: ${props.customMargin}px;
          left: ${props.customMargin}px;
        `}
  cursor: pointer;
`;
